import { FC, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  LinearProgress,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import file from "../../assets/images/icons/browsefile.svg";
import placeholder from "../../assets/images/icons/placeholderimg.svg";
// import reload from "../../assets/images/icons/reload.svg";

const UploadFile: FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Box component="section">
        <Button variant="outlined" color="primary" onClick={handleClickOpen}>
          Upload File
        </Button>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={`fullHeight ${classes.modalpages}`}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            {!isActive && (
              <img
                src={cross}
                alt="cross"
                className="cross-icon"
                onClick={handleClose}
              />
            )}
            <ProjectPoolHeading title1="Upload " title2="Your File" />

            <Box className="uploadfile pointer">
              <img src={file} alt="file" className="img-fluid" />
              <Box mb={1}>
                <Typography variant="subtitle1" color="primary">
                  Drag files here to upload or{" "}
                  <Typography
                    variant="subtitle1"
                    color="secondary"
                    component="span"
                    className="text-decoration-underline"
                  >
                    Browse file
                  </Typography>
                </Typography>
              </Box>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                Supported file types jpg,jpeg with transparent background
              </Typography>
            </Box>

            <Box mt={3}>
              <Typography variant="body1" color="secondary" className="fw-bold">
                Uploading Files
              </Typography>
              <Box display="flex" mt={2} className="uploading">
                <Box display="flex" alignItems="center" flexGrow={1}>
                  <img src={placeholder} alt="file" className="img-fluid" />
                  <Typography
                    variant="subtitle1"
                    color="secondary"
                    className="ml-16"
                  >
                    Tortor ullamcorper fusce.jpg
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  {/* show while uploading */}
                  <LinearProgress
                    variant="determinate"
                    value={80}
                    style={{ width: "93px", height: "5px" }}
                  />
                  {/* show file size when uploaded */}
                  {/* <Typography variant="subtitle1" color="primary" className='fw-normal'>
                  2.04 KB
                  </Typography> */}
                  {/* show when failed */}
                  {/* <Typography variant="subtitle1" className='fw-normal text-danger'>
                  Retry
                  </Typography>
                  <img src={reload} alt="reload" className="img-fluid ml-22 pointer" /> */}
                  <img
                    src={cross}
                    alt="cross"
                    className="img-fluid ml-22 pointer"
                  />
                </Box>
              </Box>
            </Box>

            <Box className="modal-btn-group" mt={isActive ? 3 : 5}>
              <Button
                onClick={handleClose}
                variant="contained"
                color="secondary"
                className="button-buy"
              >
                Upload
              </Button>
              <Button
                onClick={handleClose}
                variant="outlined"
                color="secondary"
                className={`button-buy ${isActive ? "ml-0 mt-0" : "ml-22"}`}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default UploadFile;
